import { fetchWrapper } from "../Helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}/ds-campaigns`;
const baseUrl_applications = `${process.env.REACT_APP_API_URL}/applications`;  
const baseUrlApplications = `${process.env.REACT_APP_API_URL}`;

export const campaignsApplicationService = {
  getCampaignApplicationById,
  getApplications,
  applyCampaignApplication,
  rejectApplication,
  getInfOpportunities,
  getInvite,
  PostInvites
};

function getCampaignApplicationById(id) {
  return fetchWrapper.get(`${baseUrl}/${id}/applications`);
}

function getApplications() {
  return fetchWrapper.get(`${baseUrlApplications}/ds-campaigns/available-list`);
}

function getInfOpportunities(params) {
  return fetchWrapper.get(`${baseUrlApplications}/me/inf-opportunities?type=${params} `);
}


function applyCampaignApplication(id, data) {
  return fetchWrapper.post(`${baseUrl}/${id}/applications`, data);
}

function rejectApplication(id, params) {
  return fetchWrapper.patch(`${baseUrl_applications}/${id}/status`, params);
}

function getInvite(campaignId) {
  return fetchWrapper.get(`${baseUrl}/${campaignId}/invites`);
}


function PostInvites(campaignId, params) {
  return fetchWrapper.post(`${baseUrl}/${campaignId}/invites`, params);
}